import Vue from "vue";
/* eslint-disable */
/** 判断微信环境 */
function inWeiXin() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

/**
 * 判断安卓或者苹果
 * return String 'Android' ,'IOS' ,'PC系统'
 * */
function phoneType() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; // android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
  if (isAndroid) {
    return "Android";
  } else if (isiOS) {
    return "IOS";
  } else {
    return "PC";
  }
}
/** 动态添加meta */
function setMeta() {
  if (!document.querySelector('meta[content="upgrade-insecure-requests"]')) {
    var oMeta = document.createElement("meta");
    oMeta.setAttribute("http-equiv", "Content-Security-Policy");
    oMeta.setAttribute("content", "upgrade-insecure-requests");
    document.getElementsByTagName("head")[0].appendChild(oMeta);
  }
}

/** 环境判断 */
function environment() {
  var devCondition = window.top.location.href.search(/test/) > -1;
  var localCondition = window.top.location.href.indexOf("localhost") > -1;
  if (!devCondition && !localCondition) {
    return true;
  } else {
    return false;
  }
}

// 设置手机app环境适配
function adaptive() {
  (function(doc, win) {
    // 分辨率适配Resolution Adaptive
    var docEl = doc.documentElement,
      resizeEvt =
        "orientationchange" in window ? "orientationchange" : "resize",
      recalc = function() {
        var clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        docEl.style.fontSize = 100 * (clientWidth / 750) + "px";
      };
    // console.log("设置html的font-size")
    // Abort if browser does not support addEventListener
    if (!doc.addEventListener) return;
    win.addEventListener(resizeEvt, recalc, false);
    doc.addEventListener("DOMContentLoaded", recalc, false);

    // 一物理像素在不同屏幕的显示效果不一样。要根据devicePixelRatio来修改meta标签的scale,要注释上面的meta标签
    (function() {
      return;
      var dpr = (scale = 1);
      var isIPhone = win.navigator.appVersion.match(/iphone/gi);
      var devicePixelRatio = win.devicePixelRatio;
      if (isIPhone) {
        // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
        if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
          dpr = 3;
        } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
          dpr = 2;
        } else {
          dpr = 1;
        }
      } else {
        // 其他设备下，仍旧使用1倍的方案
        dpr = 1;
      }
      scale = 1 / dpr;

      //
      var metaEl = "";
      metaEl = doc.createElement("meta");
      metaEl.setAttribute("name", "viewport");
      metaEl.setAttribute(
        "content",
        "initial-scale=" +
          scale +
          ", maximum-scale=" +
          scale +
          ", minimum-scale=" +
          scale +
          ", user-scalable=no"
      );
      if (docEl.firstElementChild) {
        docEl.firstElementChild.appendChild(metaEl);
      } else {
        var wrap = doc.createElement("div");
        wrap.appendChild(metaEl);
        doc.write(wrap.innerHTML);
      }
    })();
  })(document, window);
}
// 设置官网环境适配
function websiteAdaptive() {
  var userAgentInfo = navigator.userAgent;
  var Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod"
  ];
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  if (flag) {
    var winWidth =
      document.documentElement.offsetWidth || document.body.offsetWidth;

    winWidth = winWidth < 1366 ? 1366 : winWidth;

    var oHtml = document.getElementsByTagName("html")[0];

    oHtml.style.fontSize = (100 * winWidth) / 1920 + "px";

    window.addEventListener("resize", function() {
      var winWidth =
        document.documentElement.offsetWidth || document.body.offsetWidth;

      winWidth = winWidth < 1400 ? 1400 : winWidth;

      var oHtml = document.getElementsByTagName("html")[0];

      oHtml.style.fontSize = (100 * winWidth) / 1920 + "px";
    });
  } else {
    (function(doc, win) {
      // 分辨率适配Resolution Adaptive
      var docEl = doc.documentElement,
        resizeEvt =
          "orientationchange" in window ? "orientationchange" : "resize",
        recalc = function() {
          var clientWidth = docEl.clientWidth;
          // console.log(clientWidth)
          if (!clientWidth) return;
          docEl.style.fontSize = 100 * (clientWidth / 750) + "px";
        };
      // console.log("设置html的font-size")
      // Abort if browser does not support addEventListener
      if (!doc.addEventListener) return;
      win.addEventListener(resizeEvt, recalc, false);
      doc.addEventListener("DOMContentLoaded", recalc, false);

      // 一物理像素在不同屏幕的显示效果不一样。要根据devicePixelRatio来修改meta标签的scale,要注释上面的meta标签
      (function() {
        return;
        var dpr = (scale = 1);
        var isIPhone = win.navigator.appVersion.match(/iphone/gi);
        var devicePixelRatio = win.devicePixelRatio;
        if (isIPhone) {
          // iOS下，对于2和3的屏，用2倍的方案，其余的用1倍方案
          if (devicePixelRatio >= 3 && (!dpr || dpr >= 3)) {
            dpr = 3;
          } else if (devicePixelRatio >= 2 && (!dpr || dpr >= 2)) {
            dpr = 2;
          } else {
            dpr = 1;
          }
        } else {
          // 其他设备下，仍旧使用1倍的方案
          dpr = 1;
        }
        scale = 1 / dpr;

        //
        var metaEl = "";
        metaEl = doc.createElement("meta");
        metaEl.setAttribute("name", "viewport");
        metaEl.setAttribute(
          "content",
          "initial-scale=" +
            scale +
            ", maximum-scale=" +
            scale +
            ", minimum-scale=" +
            scale +
            ", user-scalable=no"
        );
        if (docEl.firstElementChild) {
          docEl.firstElementChild.appendChild(metaEl);
        } else {
          var wrap = doc.createElement("div");
          wrap.appendChild(metaEl);
          doc.write(wrap.innerHTML);
        }
      })();
    })(document, window);
  }
}
function timestampToTime(timestamp, hms = true) {
  if (!timestamp) return timestamp;
  if ((timestamp + "").length === 10) timestamp = timestamp * 1000;
  var date = new Date(timestamp); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear();
  let M =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  let D = change(date.getDate());
  let h = change(date.getHours());
  let m = change(date.getMinutes());
  let s = change(date.getSeconds());
  if (hms) {
    return `${Y}-${M}-${D} ${h}:${m}:${s}`;
  }
  return `${Y}-${M}-${D}`;
}
function timestampTime(timestamp) {
  if (!timestamp) return timestamp;
  var date = new Date(timestamp * 1000); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
  let Y = date.getFullYear() + "-";
  let M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  let D = change(date.getDate()) + " ";
  let h = change(date.getHours()) + ":";
  let m = change(date.getMinutes()) + ":";
  let s = change(date.getSeconds());
  return Y + M + D + h + m + s;
}
function change(t) {
  if (t < 10) {
    return "0" + t;
  } else {
    return t;
  }
}

// 校验字符串是否为数字
function checkStrIsNum(str) {
  const reg = /^\d+$/g;
  const result = reg.test(str);
  reg.lastIndex = 0;
  return result;
}

function moreTime() {
  let newdate = new Date().getTime();
  let olddate = localStorage.getItem("inspection_time");

  if (newdate - olddate < 18000000) {
    return true;
  } else {
    return false;
  }
}

// 日期转时间戳
function dataToTimestamp(date, type) {
  if (!date || !date.trim()) return "";
  let _date = date.replace(/-/g, "/");
  if (type === "end") {
    _date += " 23:59:59";
  }
  return new Date(_date).getTime();
}

// 屏幕尺寸变化监听
function screenResize(cb) {
  let windowWidth = window.innerWidth;
  const resizeEvt =
    "orientationchange" in window ? "orientationchange" : "resize";
  window.addEventListener(resizeEvt, () => {
    const newWindowWidth = window.innerWidth;
    if (windowWidth !== newWindowWidth) {
      cb && cb();
      windowWidth = newWindowWidth;
    }
  });
}

// 全局loading显示
function globleLoading() {
  let _loadingConfig = {
    countLoading: 0,
    loading: ""
  };
  return {
    show() {
      if (_loadingConfig.countLoading <= 0) {
        _loadingConfig.loading = Vue.$loading.show({
          width: 50,
          height: 50,
          color: "#2d8cf0",
          zIndex: 1030
        });
      }
      _loadingConfig.countLoading += 1;
    },
    // 配合其他判断条件的隐藏，手动_loadingConfig.countLoading -= 1;详细看request.js
    hide() {
      if (_loadingConfig.countLoading <= 0) {
        // Vue.$loading.show();
        // Vue.$loading.hide();
        _loadingConfig.loading && _loadingConfig.loading.hide();
      }
    },
    loadingConfig: _loadingConfig,
    // 自己调用_loadingConfig.countLoading -= 1来隐藏
    selfHide() {
      _loadingConfig.countLoading -= 1;
      this.hide();
    }
  };
}

function getObjDate(date) {
  if (date) return new Date(date);
  return new Date();
}

// function formatDataTime(date) {
//   if (date) {
//     var y = date.getFullYear();
//     var m = date.getMonth() + 1;
//     m = m < 10 ? "0" + m : m;
//     var d = date.getDate();
//     d = d < 10 ? "0" + d : d;
//     return y + "-" + m + "-" + d + " ";
//   }
// }

function getTimestamp(time, type) {
  if (typeof time === "object") {
    if (type === "start") {
      time.setHours(0);
      time.setMinutes(0);
      time.setSeconds(0);
    } else if (type === "end") {
      time.setHours(23);
      time.setMinutes(59);
      time.setSeconds(59);
    }
    return parseInt(time.getTime() / 1000);
  } else if (typeof time === "number") {
    if ((time + "").length === 13) return parseInt(time / 1000);
    else return time;
  } else return parseInt(dataToTimestamp(time, type) / 1000);
}

// 将日期格式Date 转成 xxxx-xx-xx
function getTimeFormatDate(time, hms) {
  if (typeof time === "object") {
    if (hms)
      return `${time.getFullYear()}-${addZero(time.getMonth() + 1)}-${addZero(
        time.getDate()
      )} ${addZero(time.getHours())}:${addZero(time.getMinutes())}:${addZero(
        time.getSeconds()
      )}`;
    else
      return `${time.getFullYear()}-${addZero(time.getMonth() + 1)}-${addZero(
        time.getDate()
      )}`;
  }
  return time;
}

function checkNumReg(num) {
  const regNum = /^[0-9]+$/;
  const result = regNum.test(num);
  regNum.lastIndex = 0;
  return result;
}

// 格式化成北京时间xxxx/xx/xx xx:xx:xx
// typeT: true：土耳其时间格式为 时分 日月年顺序，false：普通顺序时间
// 传入时间戳:time ，或者 tz: 时区默认8==>东八区
// function handleBJTime(time = new Date().getTime(), typeT, tz = 8) {
//   if (!time) return time;
//   if (time.toString().length === 10) time = time * 1000;
//   let getTZODate = '';
//   if (typeof time === 'number') {
//     getTZODate = handleTimeDate(time, tz);
//   } else if (typeof time === 'string') {
//     getTZODate = handleTimeDateStr(time, tz);
//   }
//   const getYear = getTZODate.getFullYear();
//   const getMonth = addZero(getTZODate.getMonth() + 1);
//   const getDate = addZero(getTZODate.getDate());
//   const getHour = addZero(getTZODate.getHours());
//   const getMinute = addZero(getTZODate.getMinutes());
//   const getSecond = addZero(getTZODate.getSeconds());
//   if (!typeT) return `${getYear}/${getMonth}/${getDate} ${getHour}:${getMinute}:${getSecond}`;
//   else return `${getHour}:${getMinute}:${getSecond} ${getDate}/${getMonth}/${getYear}`;
// }

function handleBJTime(time, typeT, tz = 8) {
  if (!time) return time;
  if (time.toString().length === 10) time = time * 1000;
  let getTZODate = new Date(time);
  const getYear = getTZODate.getFullYear();
  const getMonth = addZero(getTZODate.getMonth() + 1);
  const getDate = addZero(getTZODate.getDate());
  const getHour = addZero(getTZODate.getHours());
  const getMinute = addZero(getTZODate.getMinutes());
  const getSecond = addZero(getTZODate.getSeconds());
  if (!typeT)
    return `${getYear}/${getMonth}/${getDate} ${getHour}:${getMinute}:${getSecond}`;
  else
    return `${getHour}:${getMinute}:${getSecond} ${getDate}/${getMonth}/${getYear}`;
}
function handleBJTime_t(time, typeT, tz = 8) {
  if (!time) return time;
  if (time.toString().length === 10) time = time * 1000;
  let getTZODate = new Date(time);
  const getYear = getTZODate.getFullYear();
  const getMonth = addZero(getTZODate.getMonth() + 1);
  const getDate = addZero(getTZODate.getDate());
  const getHour = addZero(getTZODate.getHours());
  const getMinute = addZero(getTZODate.getMinutes());
  const getSecond = addZero(getTZODate.getSeconds());
  if (!typeT)
    return `${getYear}-${getMonth}-${getDate} ${getHour}:${getMinute}:${getSecond}`;
  else
    return `${getHour}:${getMinute}:${getSecond} ${getDate}/${getMonth}/${getYear}`;
}

// 返回转换指定时区的new Date对象
// time: 传入与时间戳，默认当前时间，tz：指定时区，默认东8区
function handleTimeDate(time = new Date().getTime(), tz = 8) {
  if (!time) return time;
  if (time.toString().length === 10) time = time * 1000;
  return new Date(
    time * 1 + new Date().getTimezoneOffset() * 60 * 1000 + tz * 3600 * 1000
  );
}
// 传入的time是字符串类型的时候
function handleTimeDateStr(time, tz = 8) {
  if (!time) return time;
  const tzTime = new Date().getTimezoneOffset() * 60 * 1000 + tz * 3600 * 1000;
  return new Date(new Date(time).getTime() + tzTime + tzTime);
}
// 补0 默认补两位，默认往数字前面补
function addZero(num, numSize = 2, type = "before") {
  if (!num && num !== 0) return num;
  let getNum = num.toString();
  while (getNum.length < numSize) {
    if (type === "before") {
      getNum = `0${getNum}`;
    } else {
      getNum += "0";
    }
  }
  return getNum;
}

// 获取随机数字
function getNonce() {
  let random = Math.random() * Math.pow(10, 10);
  return parseInt(random.toString().slice(1));
}

export default {
  inWeiXin: inWeiXin,
  setMeta: setMeta,
  environment: environment,
  adaptive: adaptive,
  websiteAdaptive: websiteAdaptive,
  phoneType: phoneType,
  timestampToTime: timestampToTime,
  timestampTime: timestampTime,
  checkStrIsNum,
  moreTime,
  dataToTimestamp,
  screenResize,
  globleLoading,
  getObjDate,
  getTimestamp,
  getTimeFormatDate,
  checkNumReg,
  handleBJTime,
  handleBJTime_t,
  getNonce,
  addZero
};



// WEBPACK FOOTER //
// ./src/js/until.js